(function () {
  'use strict';
  var configNode = document.getElementById('yk-delivery-config');
  if (!configNode) return;
  var config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  var text = config.text;
  var endpoint = 'https://plain-pine-1366.gayatrikartabu.workers.dev/delivery-estimate';
  function dateValue(value) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
    var date = new Date(value + 'T12:00:00Z');
    return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value ? date : null;
  }
  function dateLabel(value) {
    var date = dateValue(value);
    return date ? date.toLocaleDateString(document.documentElement.lang || 'en-IN', {day:'numeric',month:'short',year:'numeric',timeZone:'Asia/Kolkata'}) : '';
  }
  function rangeLabel(estimate) {
    if (!estimate || !estimate.available || !dateValue(estimate.from) || !dateValue(estimate.to) || estimate.from > estimate.to) return '';
    return dateLabel(estimate.from) + (estimate.from === estimate.to ? '' : ' – ' + dateLabel(estimate.to));
  }
  function orderMessage(order) {
    var status = String(order.ship || '').toUpperCase();
    var pay = String(order.pay || '').toUpperCase();
    if (order.cancelledAt || order.cancelled_at || ['CANCELLED','CANCELED','DELIVERED'].includes(status) || ['VOIDED','REFUNDED'].includes(pay)) return '';
    var estimate = order.deliveryEstimate;
    if (!estimate || !estimate.available || !dateValue(estimate.to)) return text.order_pending;
    var today = new Date(Date.now() + 19800000).toISOString().slice(0,10);
    if (estimate.to < today) return text.order_overdue;
    var latestDate = dateValue(estimate.to).toLocaleDateString('en-GB', {day:'numeric',month:'long',year:'numeric',timeZone:'Asia/Kolkata'});
    return text.free_delivery + ' ' + latestDate + '.';
  }
  window.YKDelivery = {orderMessage:orderMessage};
  function setup(widget) {
    if (widget.dataset.deliveryReady) return;
    widget.dataset.deliveryReady = 'true';
    var root = widget.closest('[id^="pp-"]');
    var pin = widget.querySelector('[data-delivery-pin]');
    var button = widget.querySelector('[data-delivery-check]');
    var result = widget.querySelector('[data-delivery-result]');
    var variantInput = document.getElementById(widget.dataset.variantInput);
    var quantityInput = document.getElementById(widget.dataset.quantityInput);
    var variants;
    try { variants = JSON.parse(widget.querySelector('[data-delivery-variants]').textContent); } catch (_) { return; }
    if (!root || !pin || !button || !result || !variantInput) return;
    var sequence = 0, controller = null;
    function selection() { return [pin.value.trim(),variantInput.value,quantityInput ? quantityInput.value : '1'].join('|'); }
    var previous = selection();
    function show(message, success) { result.style.display = 'block'; result.style.color = message === text.checking ? 'inherit' : success ? 'var(--green, #256a40)' : '#a12622'; result.textContent = message; }
    function reset() {
      var next = selection();
      if (next === previous) return;
      previous = next; sequence++;
      if (controller) controller.abort();
      button.disabled = false; button.textContent = text.check;
      result.textContent = ''; result.style.display = 'none';
    }
    pin.addEventListener('input',reset);
    root.addEventListener('change',reset);
    root.addEventListener('input',reset);
    root.addEventListener('click',function () { queueMicrotask(reset); });
    pin.addEventListener('keydown',function (event) { if (event.key === 'Enter') { event.preventDefault(); button.click(); } });
    button.addEventListener('click',async function () {
      reset();
      var postcode = pin.value.trim();
      if (!/^[1-9][0-9]{5}$/.test(postcode)) { show(text.invalid_pin); pin.focus(); return; }
      var variant = variants.find(function (item) { return String(item.id) === String(variantInput.value); });
      var quantity = Number(quantityInput ? quantityInput.value : 1);
      var packing = Number(widget.dataset.packagingGrams || 0);
      if (!variant || !variant.available) { show(text.unavailable_variant); return; }
      if (!Number.isInteger(quantity) || quantity < 1 || quantity > 10000) { show(text.invalid_quantity); return; }
      if (!Number.isFinite(packing) || packing < 0) { show(text.missing_weight); return; }
      var itemGrams = Number(variant.weight);
      if (!Number.isFinite(itemGrams) || itemGrams <= 0) itemGrams = 500;
      var weight = (itemGrams * quantity + packing) / 1000;
      if (weight > 100) { show(text.missing_weight); return; }
      var current = ++sequence;
      controller = new AbortController();
      var activeController = controller;
      var timer = setTimeout(function () { activeController.abort(); },40000);
      button.disabled = true; button.textContent = text.checking;
      delete result.dataset.deliveryError;
      show(text.checking);
      try {
        var estimates = await Promise.all(['0','1'].map(async function (cod) {
          var url = new URL(endpoint);
          url.search = new URLSearchParams({pincode:postcode,weight:String(weight),cod:cod}).toString();
          for (var attempt = 0; attempt < 2; attempt++) {
            try {
              var attemptController = new AbortController();
              var timedOut = false;
              var cancelAttempt = function () { attemptController.abort(); };
              activeController.signal.addEventListener('abort',cancelAttempt,{once:true});
              if (activeController.signal.aborted) attemptController.abort();
              var attemptTimer = setTimeout(function () { timedOut=true; attemptController.abort(); },18000);
              var response, data;
              try {
                response = await fetch(url,{signal:attemptController.signal,credentials:'omit',cache:'no-store'});
                try { data = await response.json(); }
                catch (_) { var invalid = new Error('invalid_response'); invalid.kind='response'; throw invalid; }
              } catch (requestError) {
                requestError.kind = timedOut ? 'timeout' : requestError.kind || 'connection';
                throw requestError;
              } finally {
                clearTimeout(attemptTimer);
                activeController.signal.removeEventListener('abort',cancelAttempt);
              }
              if (!response.ok || !data.ok) {
                var failure = new Error('lookup');
                failure.kind = 'api';
                failure.status = response.status;
                failure.permanent = response.status >= 400 && response.status < 500 && response.status !== 429;
                throw failure;
              }
              return data;
            } catch (error) {
              if (attempt === 1 || activeController.signal.aborted || error.permanent) throw error;
            }
          }
        }));
        if (current !== sequence) return;
        var prepaid = estimates[0], cod = estimates[1];
        if (estimates.every(function (data) { return data.serviceable === false; })) { show(text.not_serviceable); return; }
        if (estimates.some(function (data) { return data.serviceable !== false && !rangeLabel(data); })) { show(text.no_estimate); return; }
        var available = estimates.filter(function (data) { return data.serviceable !== false; });
        var later = {
          available:true,
          from:available.map(function (data) { return data.from; }).sort().pop(),
          to:available.map(function (data) { return data.to; }).sort().pop()
        };
        var qualifier = available.length === 1 ? ' (' + (prepaid.serviceable !== false ? text.prepaid_only : text.cod_only) + ')' : '';
        var latestDay = dateValue(later.to);
        var latestDate = latestDay.toLocaleDateString('en-GB', {day:'numeric',month:'long',year:'numeric',timeZone:'Asia/Kolkata'});
        show(text.free_delivery + ' ' + latestDate + '.' + qualifier, true);
      } catch (error) {
        if (current === sequence) {
          var kind = activeController.signal.aborted ? 'timeout' : error.kind || 'connection';
          result.dataset.deliveryError = kind;
          console.warn('Yuvakart delivery lookup:',kind,error.status || '');
          show(kind === 'timeout' ? text.timeout_error : kind === 'api' ? text.api_error : kind === 'response' ? text.response_error : text.connection_error);
        }
      } finally {
        clearTimeout(timer);
        if (current === sequence) { button.disabled = false; button.textContent = text.check; }
      }
    });
  }
  function init(scope) { scope.querySelectorAll('[data-yk-delivery]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load',function (event) { init(event.target); });
})();
